<script>
import UserResource from '@/resources/user'

export default {
    name: 'SubscribeField',
    methods: {
        async register() {
            try {
                let user = new UserResource({ email: this.registerEmail, username: this.registerEmail })
                let errors = user.validate()

                if(!errors.length) {
                    await user.save()
                    this.registerEmail = ''
                    this.registerMessage = { text: 'Thanks for subscribing, we\'ll keep you updated!' }
                } else {
                    this.registerMessage = { text: errors.map((e) => e.message).join('. '), variant: 'danger' }
                }
            } catch(e) {
                if(e.response?.status === 400) {
                    this.registerMessage = { text: 'There was an error adding you. Are you already subscribed?', variant: 'danger' }
                }
            }
        }
    },
    data() {
        return {
            registerEmail: '',
            registerMessage: {}
        }
    },
}
</script>

<template>
    <div>
        <b-alert :show="Object.keys(registerMessage).length > 0" :variant="registerMessage.variant">{{ registerMessage.text }}</b-alert>
        <b-form @submit.prevent="register">
            <b-input-group>
                <b-form-input v-model="registerEmail" @input="registerMessage = {}" placeholder="Entrez votre adresse e-mail" />
                <template slot="append">
                    <b-button type="submit">S'abonner</b-button>
                </template>
            </b-input-group>
        </b-form>
    </div>
</template>